/*
  Endeca configuration for the mobile search page endeca instance.

  See comments in PC search page endeca instance

*/

var site = site || {};
site.endeca = site.endeca || {};
site.endeca.instances = site.endeca.instances || {};
site.endeca.instances.search = site.endeca.instances.search || {};


jQuery(document).ready(function(){
  site.endeca.instances.search.configuration = jQuery.extend( true, {}, site.endeca.configuration, {
//     query: {
//       defaultDimensionIds: [8048,8050,8051,8052,8053,8054,8061,8062,8063,8089,8096,8127,8147,8155,8156,8157,8158,8159],
// //      defaultDimensionIds: [8061,8062,8127,8050,8063,8053,8089,8051,8096,8147,8052,8054]
//     },

    followRedirects: true,

    contentzones: {
      "Top Banner": {
        "node"                          : jQuery('.search-wrapper__banner'),
        "counted"                       : false,
        "solo"                          : false
      },
      "Bottom Banner": {
        "node"                          : jQuery('.search-wrapper__bottom_banner'),
        "counted"                       : false,
        "solo"                          : false
      },
      "Related Content": {
        "node"                          : jQuery('.search-wrapper__related_content'),
        "counted"                       : true,
        "solo"                          : true
      }
    },

    noResultsContentZone: {
      "Zero Search Results": {
        "node"                          : jQuery('.search-wrapper__no_results'),
        "counted"                       : false,
        "solo"                          : true
      }
    },

    nodes: {
      loading: jQuery('#loading')
    },

    mixins: {
      "result": site.endeca.mixins.links.address,
//      "results.products":  site.endeca.mixins.summary,
      "results.refinements": site.endeca.mixins.accordion,
      "resultsgroup.refinements": site.endeca.mixins.accordion,
      "results.products": site.endeca.mixins.powerReviews
    },

    queries: {
      product: {
        //recordsPerPage: 6,
        recordFilters: ['activeSkus', 'products']
      }
    },

    results: {
      products: {
        baseClass: 'site.endeca.results',
        instanceArgs: {
          parentNode: jQuery('#product-results')
        },
        configuration: {
          maxmimumShades: 0,
          summaryTemplatePath: '/templates/endeca/products/summary.tmpl'
        }
      },

      content: {
        baseClass: 'site.endeca.resultsgroup',
        childClass: 'site.endeca.resultsgroup.contentzones'
      },

      refinements: {
        baseClass: 'site.endeca.resultsgroup',
        instanceArgs: {
          parentNode: jQuery('#refinements')
        },
        configuration: {
          refinementTemplates: {
            'color_family': '/templates/endeca/refinements/link-shade.tmpl'
          }
        }
      },

      breadcrumbs: {
        baseClass: 'site.endeca.resultsgroup',
        instanceArgs: {
          parentNode: jQuery('#breadcrumbs'),
          resultsArgs: {
            templatePath: '/templates/endeca/breadcrumbs/link.tmpl',
            containerTemplatePath: '/templates/endeca/breadcrumbs/container.tmpl'
          }
        },
        configuration: {
          breadcrumbTemplates: {
            'color_family': '/templates/endeca/breadcrumbs/link-shade.tmpl'
          }
        }
      },

      summary: {
        baseClass: 'site.endeca.result',
        instanceArgs: {
          parentNode: jQuery('#search-summary')
        }
      },

      pagination: {
        baseClass: 'site.endeca.resultsgroup',
        configuration: {
          viewAllLink: false,
          nextPageLink: true,
          previousPageLink: true
        }
      },

      bestsellers: {
        baseClass: 'site.endeca.results',
        instanceArgs: {
          parentNode: jQuery('#bestseller-results'),
          templatePath: "/templates/endeca/products/result.tmpl"
        },
        configuration: {
          queryArgs: {
            recordsPerPage: 6,
            searchKey: 'p_ALL_CAT_IDS',
            searchTerm: 'CAT1799'
          },
          maxmimumShades: 0,
        }
      }
    }
  });

  site.endeca.instances.search.configuration.query.defaultDimensionIds = [8061, 8174, 8063, 8050, 8089, 8051, 9, 6];

  new site.endeca.instances.search.control( site.endeca.instances.search.configuration );

});
